import { Badge, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { FC } from "react";
import MappedIcon from "~/icons/Mapped";
import SkippedIcon from "~/icons/Skipped";
import PendingReviewIcon from "~/icons/PendingReview";
import { useDataCatalogContext } from "./dataCatalogContext/DataCatalogContext";
import { EncryptMappingStatus } from "~/gen/api/governance";


const EncryptStatusStatistics: FC = () => {
  const { pushCriteria, encryptStatusStatistics } = useDataCatalogContext()
  const pickEncryptStatus = (x:EncryptMappingStatus) => () => {
    pushCriteria({
      kind: 'EncryptStatus',
      encryptStatus: x,
    })
  }
  
  return (
    <Stack direction="row" alignItems="baseline" sx={{ mb: 4 }}>
      <Typography variant="body1" color="text.secondary">Encryptions:</Typography>
      <Stack direction="row" spacing={1}>
        <Tooltip title="Mapped">
          <IconButton onClick={pickEncryptStatus(EncryptMappingStatus.Mapped)} color={"info" as any}>
            <Badge color={"success" as any} badgeContent={encryptStatusStatistics?.mappedCount || 0} showZero max={9999}>
              <MappedIcon />
            </Badge>
          </IconButton>
        </Tooltip>

        <Tooltip title="Skipped">
          <IconButton onClick={pickEncryptStatus(EncryptMappingStatus.Skipped)} color={"info"}>
            <Badge color="secondary" badgeContent={encryptStatusStatistics?.skippedCount || 0} showZero max={9999}>
              <SkippedIcon />
            </Badge>
          </IconButton>
        </Tooltip>

        <Tooltip title="Pending Review">
          <IconButton onClick={pickEncryptStatus(EncryptMappingStatus.PendingReview)} color={"info" as any}>
            <Badge color={"warning" as any} badgeContent={encryptStatusStatistics?.pendingReviewCount || 0} showZero max={9999}
              sx={{ 'span.MuiBadge-badge': {color: theme => theme.palette.mode === 'light' ? 'black!important' : undefined }}}
            >
              <PendingReviewIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </Stack>
    </Stack>
  )
}

export default EncryptStatusStatistics;
